const inputStyles =
  'mt-1 py-1 px-2 border border-gray-300 bg-white rounded-md shadow-xs focus:outline-hidden focus:ring-indigo-500 focus:border-indigo-500';

export default inputStyles;
